import { global_business_line_carousel } from '../../utils/requests/contentstack/contentStackZodSchema';
import { type BusinessLineCarouselProps } from './BusinessLineCarousel';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';
export const businessLineCarouselSchema = global_business_line_carousel.transform<BusinessLineCarouselProps>(data => ({
  businessLinesHeader: {
    title: data.header.title,
    description: data.header.description,
    descriptionLinks: data.header.description_links.map(descriptionLink => {
      return {
        href: descriptionLink.href,
        text: descriptionLink.title
      };
    })
  },
  businessLines: data.business_lines.map<BusinessLineCarouselProps['businessLines'][number]>(businessLine => ({
    linkHref: businessLine.link.href,
    linkLabel: businessLine.link.title,
    image: getCloudinaryImageFields({
      alt: businessLine.image.alt,
      cloudinaryField: businessLine.image.src,
      shouldUseV2: true
    })
  }))
}));